module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAAAXNSR0IArs4c6QAAAGZJREFUOBFj/O/gIMHw799pxkOHZBkoBP9tbSUZGBnPMTH8/csINIuFQvNQtDOh8KjEGTWUSgGJZMxomCIFBpWYIzxMIQXJ//8SwBKmkQpBKskANAtUQjEADfQGFlkmVDAUaNj/zQDetBVsprARrAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/Manual Suspend.png
// module id = 308
// module chunks = 7